<template>
<div>
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggleMenu($event)" aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-text p-button-sm mt-0 mr-1"   />
<Menu id="overlay_menu" ref="menu" :model="usermenuitems" :popup="true">
<template #item="{item}">  

<a class="p-menuitem-link" role="menuitem" @click="item.command()">
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>


</template>
</Menu>

</div>
</template>

<script>
export default {

  name: 'PlannerTableTemplateSidebarTabListItem',
  props:["data"],
  data () {
    return {

    }
  },
  computed:{
  	usermenuitems()
    {
      let share_tag = "Paylaşımı Durdur"
      if(this.data.share_with_brand_users)
      {
      	share_tag = "Paylaş"
      }
      return [
          {
              label: 'Uygula',
              icon: 'pi pi-play',
              command: () => {
                    this.$emit("applyFilter",this.data.id)
                    this.$refs.menu.hide();
                  }
          }, 
          {
              label: 'Düzenle',
              icon: 'pi pi-pencil',
              command: () => {
                    this.$emit("editFilter",this.data.id)
                    this.$refs.menu.hide();
                  }
          },
          {
              label: share_tag,
              icon: 'pi pi-share-alt',
              command: () => {
                    this.$emit("shareWithUsers",this.data.id)
                    this.$refs.menu.hide();
                  }
          },
          {
              label: "Sil",
              icon: 'pi pi-trash',
              command: () => {                    
                    this.$refs.menu.hide();
                  }
          },

      ]
    },
  },
  methods:{
  	toggleMenu(event)
    {
      this.$refs.menu.toggle(event)
    },
  }
}
</script>

<style lang="css" scoped>
</style>